import { Card, CardContent, Container, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import FormSendEmailDelete from 'src/Patient/deleteUser/components/FormSendEmailDelete'
import FormConfirmDelete from 'src/Patient/deleteUser/components/FormConfirmDelete'
import FormCodeDeleteUser from 'src/Patient/deleteUser/components/FormCodeDeleteUser'
//import { activeStepResetPasswordState, completedStepResetPasswordState } from 'src/Patient/recoveryPassword/state/atoms'
import { activeStepDeleteUserState   , completedStepDeleteUserState }  from 'src/Patient/deleteUser/state/atoms'
import FormResetPassword from 'src/Patient/recoveryPassword/components/FormResetPassword'
import { errorsFormRegisterState, rulesPasswordState, valuesFormRegisterState } from 'src/Patient/state/atoms'
import { showBannerState } from 'src/store/global/bannerShowState'
import { headerShowState } from "src/store/global/headerShowState";
import { stepperRecoveryPasswordShowState , stepperDeleteUserShowState} from 'src/store/global/steppersShowState'
import useSEO from 'src/Hooks/useSEO';

const DeleteUser = () => {
    const activeStepDeleteUSer = useRecoilValue(activeStepDeleteUserState);

    const resetPatientInformation = useResetRecoilState(valuesFormRegisterState);
    const resetPatientErrors = useResetRecoilState(errorsFormRegisterState);
    const resetRulesPassword = useResetRecoilState(rulesPasswordState);
    const resetActiveStepDeleteUser = useResetRecoilState(activeStepDeleteUserState);
    const resetCompletedStepDeleteUser = useResetRecoilState(completedStepDeleteUserState);
    const setShowBanner = useSetRecoilState(showBannerState);
    const setShowHeader = useSetRecoilState(headerShowState);
    //const stepperRecoveryPasswordShow  = useSetRecoilState(stepperRecoveryPasswordShowState);
    const stepperDeleteUserShow  = useSetRecoilState(stepperDeleteUserShowState);
    
    useSEO({title: 'Eliminar Cuenta Usuario'});
    
    useEffect(() => {
        setShowBanner(false);
        setShowHeader(false);
        //stepperRecoveryPasswordShow(true);
        stepperDeleteUserShow(true);
        return () => {
            setShowBanner(true);
            //stepperRecoveryPasswordShow(false);
            stepperDeleteUserShow(false);
            resetPatientInformation();
            resetPatientErrors();
            resetRulesPassword();
            resetActiveStepDeleteUser();
            resetCompletedStepDeleteUser();
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container style={{ maxWidth: 600 }}>
            {/* <StepsResetPassword color={theme.palette.primary.main} /> */}
            <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
                ELIMINACIÓN DE CUENTAS
            </Typography>
            {/* <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
                INGRESE SUS DATOS
            </Typography> */}

            <Card>
                <CardContent>
                    { activeStepDeleteUSer === 0 && <FormSendEmailDelete />}
                    { activeStepDeleteUSer === 1 && <FormConfirmDelete />}
                    { activeStepDeleteUSer === 2 && <FormCodeDeleteUser />}
                </CardContent>
            </Card>
        </Container>
    )
}

export default DeleteUser;